<ng-container *ngIf="isLoading">
  <div class="entity-loading">
    <i class="fas fa-spinner fa-spin"></i>
  </div>
</ng-container>
<ng-container *ngIf="!isLoading">
  <ng-content></ng-content>
</ng-container>
